import styled from "styled-components";

export default styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: var(--main-bg-color);
  display: flex;
  justify-content: center;
  align-items: center;
`;
